import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StripeComponent } from './stripe.component';

@NgModule({
    declarations: [StripeComponent],
    imports: [
        CommonModule
    ],
    exports: [StripeComponent],
})
export class StripeModule {}
